export const BoardModule = {
    namespaced: true,
    state: {
        loadBoardData: 1,
        BoardList: [],
        BoardFilterList: []
    }
}